export interface LoginModel {
    email: string;
    password: string;
}

export const getEmptyLoginModel = (): LoginModel => <LoginModel>{};

export interface ChangePasswordModel {
    oldPassword: string;
    newPassword: string;
    confirmNewPassword: string;
}

export const getEmptyPasswordModel = (): ChangePasswordModel => {
    return {
        oldPassword: "",
        newPassword: "",
        confirmNewPassword: ""
    }
}

export enum UserRole {
    Admin = "Administrator",
}


// WEBPACK FOOTER //
// ./src/login/LoginModels.ts